import "./footer.css";

const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer__container container">
        <ul className="footer__list">
          <li><a href="#skills" className="footer__link">Expertise</a></li>
          <li><a href="#work" className="footer__link">Work</a></li>
          <li><a href="#about" className="footer__link">About</a></li>
          <li><a href="#contact" className="footer__link">Contact</a></li>
          <li><a href="#faq" className="footer__link">FAQ</a></li>
        </ul>

        <span className="footer__copy">
          &#169; {new Date().getFullYear()} Rishabh Banerjee. All rights reserved.
        </span>
      </div>
    </footer>
  );
};

export default Footer;
